import { SingleSelectExample, MultiSelectExample } from "../../../../../../packages/design-system/src/AutocompleteInput/readme-helpers";
import * as React from 'react';
export default {
  SingleSelectExample,
  MultiSelectExample,
  React
};